import { KebabMenuItem } from '@library/components/menus';
import type { Status } from '@library/types/projection';
import { StatusIndicator } from '@library/components/StatusIndicator';
import { getTooltipForStatus } from '@library/utils/status';
import { statuses } from '@library/constants/statuses';

export interface StatusKebabMenuItemsProps {
  disabled?: boolean;
  isBulkInGameEnabled: boolean;
  handleChangeStatus: (status: Status) => void;
  handleChangeInGame?: (inGame: boolean) => void;
  handleShowAutoTradeDrawer?: () => void;
  handleShowGameModes?: () => void;
}

export const StatusKebabMenuItems = ({
  disabled = false,
  isBulkInGameEnabled,
  handleChangeStatus,
  handleChangeInGame,
  handleShowAutoTradeDrawer,
  handleShowGameModes
}: StatusKebabMenuItemsProps) => {
  const autoTradeDrawerOption = handleShowAutoTradeDrawer && (
    <KebabMenuItem
      key="AutoTrade"
      className="text-soClean-100 hover:bg-soFresh-120 flex h-7 w-full items-center rounded-md px-2 text-xs"
      disabled={disabled}
      handleOnClick={handleShowAutoTradeDrawer}
      itemActiveClassName="bg-stankonia-100"
    >
      <span className="pl-2">Show Player History</span>
    </KebabMenuItem>
  );

  const gameModesOption = handleShowGameModes && (
    <KebabMenuItem
      key="GameModes"
      className="text-soClean-100 hover:bg-soFresh-120 flex h-7 w-full items-center rounded-md px-2 text-xs"
      disabled={disabled}
      handleOnClick={handleShowGameModes}
      itemActiveClassName="bg-stankonia-100"
    >
      <span className="pl-2">Change Game Modes</span>
    </KebabMenuItem>
  );

  const inGameOption = handleChangeInGame && (
    <KebabMenuItem
      key="InGame"
      className="text-soClean-100 hover:bg-soFresh-120 flex h-7 w-full items-center rounded-md px-2 text-xs"
      disabled={disabled}
      handleOnClick={() => handleChangeInGame(!isBulkInGameEnabled)}
      itemActiveClassName="bg-stankonia-100"
    >
      <span className="pl-2">{`${!isBulkInGameEnabled ? 'Enable' : 'Disable'} In Game`}</span>
    </KebabMenuItem>
  );

  const statusOptions = statuses.map((statusType) => {
    const message = `Set player to ${getTooltipForStatus(statusType)}`;

    return (
      <KebabMenuItem
        key={message}
        className="text-soClean-100 hover:bg-soFresh-120 flex h-7 w-full items-center rounded-md px-2 text-xs"
        disabled={disabled}
        handleOnClick={() => handleChangeStatus(statusType)}
        itemActiveClassName="bg-stankonia-100"
      >
        <StatusIndicator status={statusType} />{' '}
        <span className="pl-2">{message}</span>
      </KebabMenuItem>
    );
  });

  return [
    autoTradeDrawerOption,
    gameModesOption,
    inGameOption,
    ...statusOptions
  ];
};
